<template>
    <div class="varied-input xy-start">
        <div class="auto-grow" v-show="isUseQuill">
            <div ref="editor"></div>
        </div>
        <div
            v-if="!isUseQuill"
            class="content-box"
            @click.stop="isUseQuill = true"
        >
            <question-show :data="inputValue"></question-show>
        </div>
        <!-- <el-input
            v-show="!isUseQuill"
            v-model="inputValue"
            placeholder="请输入..."
            autofocus
            @input="changeValue"
            @focus="isUseQuill = true"
        ></el-input> -->
        <div
            class="mode-btn xy-center pointer no-wrap"
            @click="isUseQuill = !isUseQuill"
        >
            {{ isUseQuill ? "收起" : "展开" }}
            <i
                :class="[
                    isUseQuill ? 'el-icon-arrow-up' : 'el-icon-arrow-down',
                ]"
            ></i>
        </div>
    </div>
</template>
<script>
import Quill from "quill";
import { uploadFile } from "@/api/manage.js";
import QuestionShow from "@/components/manager/resource/QuestionShow";
export default {
    components: { QuestionShow },
    props: {
        inputContent: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            inputValue: "",
            isUseQuill: false,
            htmlValue: "",
        };
    },
    destroyed() {
        if (this.quill) {
            delete this.quill
        }
    },
    mounted() {
        this.inputValue = this.inputContent;
        this.initQuill();
    },
    watch: {
        inputContent(inputContent) {
            this.inputValue = inputContent;
        },
        isUseQuill(isUseQuill) {
            if (isUseQuill) {
                this.quill.pasteHTML(this.inputValue);
                this.$nextTick(() => {
                    this.quill.focus()
                })
            }
        },
    },
    methods: {
        initQuill() {
            if (this.quill) return;
            const quill = new Quill(this.$refs.editor, {
                theme: "snow",
                modules: {
                    toolbar: {
                        container: [
                            ["bold", "italic", "underline", "strike"],
                            [{ list: "ordered" }],
                            [{ script: "sub" }, { script: "super" }],
                            [{ color: [] }, { background: [] }],
                            ["image"],
                        ],
                    },
                },
                placeholder: "请输入...",
            });
            this.quill = quill;
            quill.on("text-change", (val) => {
                // console.log("value:", quill.root.innerHTML);
                this.inputValue = quill.root.innerHTML;
                this.changeValue();
            });
            const toolbar = quill.getModule("toolbar");
            toolbar.addHandler("image", this.uploadImg);
            quill.root.addEventListener(
                "paste",
                (evt) => {
                    if (
                        evt.clipboardData &&
                        evt.clipboardData.files &&
                        evt.clipboardData.files.length
                    ) {
                        let files = [];
                        for (
                            let i = 0;
                            i < evt.clipboardData.files.length;
                            i++
                        ) {
                            files.push(evt.clipboardData.files[i]);
                        }
                        files = files.filter((file) =>
                            file.type.match(/^image\/(gif|jpe?g|a?png|bmp)/i)
                        );
                        if (files.length > 0) {
                            evt.preventDefault();
                            files = files.filter((v) => {
                                if (v.size > 10 * 1024 * 1024) {
                                    this.$notify({
                                        title: "警告",
                                        message: "粘贴图片大于10M已被忽略",
                                        type: "warning",
                                    });
                                    return false;
                                }
                                return true;
                            });
                            if (files.length > 0) {
                                const loading = this.$loading({
                                    lock: true,
                                    text: "图片上传中",
                                    spinner: "el-icon-loading",
                                    background: "rgba(0, 0, 0, 0.5)",
                                });
                                Promise.all(
                                    files.map(async (file) => {
                                        return uploadFile(
                                            {
                                                file,
                                            },
                                            (process) => {
                                                console.log(process);
                                            }
                                        );
                                    })
                                )
                                    .then((res) => {
                                        for (let url of res) {
                                            if (!url) continue;
                                            const range = quill.getSelection();
                                            quill.insertEmbed(
                                                range.index,
                                                "image",
                                                url
                                            );
                                        }
                                    })
                                    .catch((e) => {
                                        // console.log("eee:", e);
                                        this.$message.error("图片上传失败");
                                    })
                                    .finally(() => loading.close());
                            }
                        }
                    }
                },
                false
            );
        },
        changeValue() {
            this.$emit("update:inputContent", this.inputValue);
        },
        uploadImg() {
            const range = this.quill.getSelection();
            if (range) {
                const index = range.index;
                this.selectFile(
                    (file) => {
                        // console.log(file);
                        const loading = this.$loading({
                            lock: true,
                            text: "图片上传中",
                            spinner: "el-icon-loading",
                            background: "rgba(0, 0, 0, 0.5)",
                        });
                        uploadFile(
                            {
                                file,
                            },
                            (process) => {
                                console.log(process);
                            }
                        )
                            .then((res) => {
                                console.log(res);

                                this.quill.insertEmbed(index, "image", res);
                                setTimeout(() => {
                                    loading.close();
                                }, 500);
                            })
                            .catch((e) => {
                                console.log("eee:", e);
                                loading.close();
                                this.$message.error("图片上传失败");
                            });
                    },
                    (dom) => {
                        dom.accept =
                            "image/jpg,image/png,image/jpeg,image/gif,";
                    }
                );
            }
        },
        selectFile(call, domSetting = (dom) => {}) {
            const dom = document.createElement("input");
            dom.type = "file";
            dom.style.display = "none";
            domSetting(dom);
            dom.onchange = (event) => {
                if (event.target.files && event.target.files.length > 0) {
                    call(event.target.files[0]);
                }
            };
            dom.click();
        },

        htmlToContent() {
            this.htmlValue = this.$refs.editor.children[0].innerHTML;
            this.changeValue();
        },
        cleanContent() {
            this.quill.setText("\n");
        }
    },
};
</script>

<style lang="less" scoped>
.varied-input::v-deep {
    .el-input {
        height: 36px;
        input {
            height: 36px;
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
        }
    }
    .mode-btn {
        width: 60px;
        min-width: 60px;
        height: 36px;
        border: 1px solid #e5e8ec;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        box-sizing: border-box;
        border-left: none;
    }
    .ql-toolbar {
        height: 36px;
        padding: 0;
        padding-top: 4px;
    }
    .ql-container {
        img {
            width: 120px;
        }
    }
    .content-box {
        width: 100%;
        padding: 2px 5px;
        border: 1px solid #ccc;
        border-radius: 4px 0 4px 4px;
        min-height: 36px;
        box-sizing: border-box;
    }
}
</style>
